var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "confirmation-city-picker" }, [
    _c(
      "div",
      {
        staticClass:
          "confirmation-city-picker__title txt-subtitle txt-blue-common"
      },
      [_vm._v("\n    Ваш регион\n  ")]
    ),
    _vm._v(" "),
    _vm.city
      ? _c("div", { staticClass: "confirmation-city-picker__city" }, [
          _vm._v("\n    " + _vm._s(_vm.city) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "confirmation-city-picker__description" }, [
      _vm._v(
        "\n    Укажите ваш город, чтобы мы рассчитали зону доставки товаров\n  "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "confirmation-city-picker__footer" }, [
      _c(
        "button",
        {
          staticClass: "btn-ui btn-ui--full-mob",
          attrs: { type: "button" },
          on: { click: _vm.onContinue }
        },
        [_vm._v("\n      Продолжить\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-ui btn-ui--secondary btn-ui--full-mob",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("on-edit")
            }
          }
        },
        [_vm._v("\n      Нет, изменить\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }